var render, staticRenderFns
import script from "./accredit.vue?vue&type=script&lang=js"
export * from "./accredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca35b9cc",
  null
  
)

export default component.exports